import React from 'react';
import ReportPage from './ReportPage';

function Reports() {
   return <ReportPage />;
}

export default Reports;
